<!--  -->
<template>
    <div class="business-content-main sysconfig-edit">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="config-table">
            <ux-grid ref="infiniteTable" :data="tableData" keep-source :edit-config="{ trigger: 'click', mode: 'row' }" highlight-current-row>
                <ux-table-column class-name="table-sort" type="index" title="序号" width="50"></ux-table-column>

                <ux-table-column title="一企管功能" width="340">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.CTitle }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" class-name="table-op" width="90">
                    <template v-slot="{ row, rowIndex }">
                        <el-switch v-model="tableData[rowIndex].Result" active-color="#13ce66" inactive-color="#b1b1b1" @change="changeResult(row.RId)"></el-switch>
                    </template>
                </ux-table-column>
                <ux-table-column title="说明">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.CDesc }}</div>
                    </template>
                </ux-table-column>

                <ux-table-column title="结果值" width="200" edit-render>
                    <template v-slot="{ row }">
                        <div class="div-padding-12" v-if="row.IsCanset">{{ row.RValue }}</div>
                        <div class="div-unedit" v-else>( 不可编辑 )</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            size="small"
                            v-model="scope.row.RValue"
                            v-if="scope.row.IsCanset"
                            @change="changeInputResult($event, scope.row.RId, scope.row.IsNum, scope.row.Code)"
                        ></el-input>
                        <div v-else class="div-unedit">( 不可编辑 )</div>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: { breadcrumb },
    data() {
        return {
            tableData: [],
            tableDataLength: 0,
            permission: {}
        };
    },
    mounted() {
        this.getTableData();
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.permission = this.$util.getPermission('sysConfigs');
    },
    methods: {
        // 改变状态
        changeResult(rId) {
            this.$util
                .axiosPost({
                    url: '/api/EntpInfoManagement/UpdateSysConfigResultsById',
                    data: {
                        ConfigId: rId
                    }
                })
                .then(() => {
                    this.$util.successMsg('配置成功');
                })
                .catch(() => {
                    this.getTableData();
                });
        },
        changeInputResult(val, rId, isNum, code) {
            let that = this;
            if (isNum) {
                if (isNaN(val)) {
                    that.$message.error('修改的值必须为数字类型');
                    return;
                }
                if (code == 'pagesetlimit' && val > 50) {
                    that.$message.error('自定义每页条目数不可超过50');
                    return;
                }
                if (code == 'pagesetlimit' && val == 0) {
                    that.$message.error('自定义每页条目数不可为0');
                    return;
                }
                if (code == 'pagesetlimit') {
                    val = Number(val).toFixed(0);
                }
            }
            that.$util
                .axiosPost({
                    url: '/api/EntpInfoManagement/UpdateEntpResultsById',
                    data: {
                        ConfigId: rId,
                        RResult: val
                    }
                })
                .then(() => {
                    if (code == 'pagesetlimit') that.$util.setLocalStorage('p_limit', val);
                    that.$util.successMsg('配置成功');
                })
                .catch(() => {
                    that.getTableData();
                });
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetEnterpriseSysConfigResults'
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        }
    }
};
</script>
<style lang="less">
.sysconfig-edit {
    .elx-table {
        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }
                .table-op {
                    .elx-cell {
                        padding: 2px 12px 0;
                    }
                }
                .div-padding-12 {
                    padding: 4px 12px 0;
                }
                .div-unedit {
                    padding: 4px 12px 0;
                    color: rgb(185, 184, 184);
                    font-size: 12px;
                }
                .operate {
                    padding: 0 12px;
                }
                td {
                    height: 28px;
                }
            }
            .elx-cell {
                padding: 0;
                height: 32px;
            }
            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }
    }
}
.config-table {
    margin-top: 20px;
    margin-bottom: 30px;
}
</style>
